import { type ReactNode } from 'react';
import { cn } from '../../lib/utils';

/**
 * A small, uppercase status pill with a single, consistent shape across the app
 * (impact, confidence, risk, …). Pass a `color` (a CSS colour / token) for a
 * tinted, coloured pill; omit it for the neutral, hairline-bordered variant.
 */
export function Pill({
  color,
  title,
  className,
  children,
}: {
  color?: string;
  title?: string;
  className?: string;
  children: ReactNode;
}) {
  const base =
    'inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-[0.6rem] font-semibold uppercase tracking-wide';
  if (!color) {
    return (
      <span className={cn(base, 'border-hairline text-muted', className)} title={title}>
        {children}
      </span>
    );
  }
  // color-mix keeps the tint valid whether `color` is a hex value or a CSS token.
  return (
    <span
      className={cn(base, className)}
      style={{
        backgroundColor: `color-mix(in srgb, ${color} 12%, transparent)`,
        borderColor: `color-mix(in srgb, ${color} 45%, transparent)`,
        color,
      }}
      title={title}
    >
      {children}
    </span>
  );
}
